import React from "react"
import SlickSlider from "../components/react-slick"

export default function Home() {
  return (
    <div className="wrapper">
      <h1>React Slick</h1>
      <SlickSlider />
      {/* <div className="link">
        <a href="https://okuhira.studio/react-slick/">記事に戻る</a>
      </div> */}
    </div>
  )
}
